import { Icon } from '@synergy/icons';
import { Button as ButtonAntd, Col, Flex, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from 'styled-components';
import { Field, PageContent } from "../../styles/global/Pages.styled";
import Theme from "../../styles/Theme/Theme";
import { Button } from "../Global/Atomics/Button";
import { Text } from "../Global/Atomics/Text";
import { elementTypes, getTextForTranslation } from "../Global/Molecules/BuildingDetails/BuildingDetail/Digital Twin/DigitalTwinConfig/DigitalTwinConfig";

const TooltipContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
    position: relative;
    height: 20px;
`;

export const DigitalTwinDrawerDetail = ({ itemSelected, openMetricsPopUp, showMetricButton }) => {
  const { t } = useTranslation();
  const [filteredItem, setFilteredItem] = useState(null);

  const keysWithTooltip = ["weight", "is_peer", "inVName", "outVName"]

  useEffect(() => {
    try {
      if (itemSelected) {
        var keysToKeep;
        if ((itemSelected.label === "Incident")) {
          keysToKeep = [
            "reference_number",
            "priority",
            "category",
            "service_class",
            "open_date",
            "status",
          ];
        } else if (itemSelected.elementType === elementTypes.node) {
          keysToKeep = [
            "name",
            "class",
            "family",
            "type",
            "label",
            "status",
            "layer",
          ];
        } else {
          keysToKeep = [
            "label",
            "weight",
            "is_peer",
            "inVName",
            "outVName",

          ];
        }
        const filtered = Object.keys(itemSelected)
          .filter((key) => keysToKeep.includes(key))
          .sort((a, b) => keysToKeep.indexOf(a) - keysToKeep.indexOf(b))
          .reduce((obj, key) => {
            obj[key] = itemSelected[key];
            return obj;
          }, {});
        setFilteredItem(filtered);
      }
    } catch (error) {
      console.error(
        "(DigitalTwinDrawerDetail page) Error in useEffect setting registryDetailData:",
        error
      );
      //reportError(error); // Send error report to backend
    }
  }, [itemSelected]);

  return (
    <PageContent $backgroundColor="white">
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Row gutter={[16, 16]}>
            {filteredItem && Object.keys(filteredItem)?.map((key, index) => {
              return (
                <Col span={24} key={index} className='d-flex'>
                  <Field id={index} $backgroundColor="neutral-3" className='full-width' >
                    <TooltipContainer>
                      <Text $fontColor='coolgray-10' $fontSize='text_xs' $weight='regular'>{t(getTextForTranslation(key))}</Text>
                      {keysWithTooltip.includes(key) &&
                        <Tooltip
                          title={t(`Drawer ${getTextForTranslation(key)} Tooltip`)}
                          color={Theme.color.white}
                          colorText={Theme.color["coolgray-12"]}
                          className="widget-tooltip"
                        >
                          <ButtonAntd
                            shape="circle"
                            type="text"
                            icon={
                              <Icon icon={"Information"} iconsize="xs" color="blue-4" />
                            }
                          />
                        </Tooltip>}
                    </TooltipContainer>

                    <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='regular'>{filteredItem[key] && filteredItem[key] != '' ? filteredItem[key] : '-'}</Text>
                  </Field>
                </Col>
              )
            })}
          </Row>
        </Col>
      </Row>

      <Row gutter={[32, 32]} style={{ marginTop: "40px" }}>
        <Col span={24}>
          <Row gutter={[16, 16]}>
            {showMetricButton &&
              <Col span={24} >
                <Flex align="center" justify="center">
                  <Button
                    $backgroundColor={Theme.color["blue-4"]}
                    size="xs"
                    $color="white"
                    width="100%"
                    onClick={openMetricsPopUp}
                  >
                    {t("Show Metrics")}
                  </Button>
                </Flex>
              </Col>}
          </Row>
        </Col>
      </Row>
    </PageContent>
  );
};